module.exports = __webpack_public_path__ + "static/media/Login_Garena.9e19e699.jpg";